// extracted by mini-css-extract-plugin
module.exports = {"tabTitles":"styles_tabTitles__TS7aD","tabContentTitle":"styles_tabContentTitle__3Q2jN","tabContentList":"styles_tabContentList__7cb8p","vodafoneBannerWrapper":"styles_vodafoneBannerWrapper__9YiMi"};
module.exports.__checksum = "dcd3d8d5f8b4"
